"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
CartButtonDirective.$inject = ['api', '_cart', '_shop', 'notify', '_analytics'];
function CartButtonDirective(api, _cart, _shop, notify, _analytics) {
    return {
        scope: {
            product: '=',
            class: '='
        },
        template: require('./views/cart-button.html'),
        link: function (scope, element, attrs, ngModel) {
            scope.loading = false;
            scope.addToCart = function () {
                if (!scope.product.price || scope.loading) {
                    return;
                }
                scope.loading = true;
                var normalizedPrice = scope.product.price && scope.product.price > 0 ? scope.product.price : 0;
                var finalPrice = scope.product.price_discount && (normalizedPrice === 0 || scope.product.price_discount < normalizedPrice)
                    ? scope.product.price_discount
                    : normalizedPrice;
                var data = {
                    product_id: scope.product._id,
                    quantity: 1,
                    price: finalPrice
                };
                _cart.add(data).then(function (response) {
                    _cart.setCartTotal(response.total);
                    _cart.setCartTotalVat(response.total_vat);
                    _cart.setCartSize(response.cart_size);
                    _cart.setCartTotalQuantity(response.quantity_total);
                    scope.product.quantity = response.item.quantity;
                    scope.product.cart_id = response.item._id;
                    _analytics.addToCart({
                        "id": scope.product._id,
                        "name": scope.product.name,
                        "quantity": 1,
                        "price": finalPrice
                    });
                    scope.loading = false;
                }, function (error) {
                    scope.loading = false;
                    console.log('error');
                });
            };
            scope.addOne = function () {
                // Prevent increasing quantity above 1 for damaged products
                if (scope.product && scope.product.damaged_product && scope.product.quantity >= 1) {
                    return;
                }
                update({ quantity: scope.product.quantity + 1 });
            };
            scope.removeOne = function () {
                update({ quantity: scope.product.quantity - 1 });
            };
            function update(data) {
                if (scope.loading) {
                    return;
                }
                scope.loading = true;
                _cart.update(scope.product, data).then(function (response) {
                    scope.product.quantity = response.item.quantity;
                    if (response.item.quantity == 0) {
                        var normalizedPrice = scope.product.price && scope.product.price > 0 ? scope.product.price : 0;
                        var finalPrice = scope.product.price_discount && (normalizedPrice === 0 || scope.product.price_discount < normalizedPrice)
                            ? scope.product.price_discount
                            : normalizedPrice;
                        _analytics.removeFromCart({
                            "id": scope.product._id,
                            "name": scope.product.name,
                            "quantity": 0,
                            "price": finalPrice
                        });
                    }
                    _cart.updateTotal();
                    scope.loading = false;
                }, function (error) {
                    console.log('error');
                    scope.loading = false;
                });
            }
            scope.openStockModal = function () {
                _shop.openStockModal(scope.product).then(function (response) {
                    notify.success('Vaš upit je uspešno poslat.');
                }, function (error) {
                    console.log('error');
                });
            };
        }
    };
}
exports.CartButtonDirective = CartButtonDirective;



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/shop/directives/CartButtonDirective.js
// module id = 369
// module chunks = 0